import {
  Offer,
} from "@assets/types"

export const promotionHasMassiveSeal = (promotion: Offer | undefined) =>
  promotion?.type == "MASSIVE"
  && promotion?.requiresIdentification
  && window.parameters.glob_massive_id_seal